export const breakpoints = {
  1400: {
    slidesPerView: 5.5,
    spaceBetween: 0
  },
  1200: {
    slidesPerView: 5.5,
    spaceBetween: 0
  },
  768: {
    slidesPerView: 4.5,
    spaceBetween: 0
  },
  400: {
    slidesPerView: 2.5,
    spaceBetween: 0
  },
  200: {
    slidesPerView: 2.5,
    spaceBetween: 0
  }
};
